module.exports = __webpack_public_path__ + "static/media/humidity.891d9ea7.svg";